/** Definicion de rutas asociadas al modulo de muestras covid19 */
const muestrasRouter = [
	{
		path: '/muestras',
		name: 'muestras',
		meta: {
			layout: 'default',
		},
		component: () => import('@/views/muestras/Muestras.vue'),

		redirect: () => {
			return {
				name: 'actualizarInformacion'
			};
		},

		children: [

			/** Ruta donde se actualiza la informacion del usuario. Se actualiza informacion de contacto y contactos estrechos */
			{
				path: 'actualizar_informacion/:hash?',
				name: 'actualizarInformacion',
				component: () => import('@/views/muestras/actualizar_infomacion/ActualizarInformacion.vue'),
				meta: {
					requiresAuth: true
				}
			},

			/** Ruta para el ingreso de usuarios desde el correo electronico por medio del hash */
			{
				path: 'resultados_correo/:hash',
				name: 'resultadosCorreo',
				component: () => import('@/views/muestras/actualizar_infomacion/ActualizarInformacion.vue'),
			},

			/** Pantalla principal del modulo, contiene dos pestañas: resultados y certificados */
			{
				path: 'principal',
				name: 'principal',
				meta: {
					layout: 'blank',
					requiresAuth: true
				},
				component: () => import('@/views/muestras/principal/Principal.vue'),
				redirect: ()=> {
					return {
						name: 'previsualizarResultados'
					}
				},
				children: [
					{
						path: 'previsualizar_resultados',
						name: 'previsualizarResultados',
						component: () => import('@/views/muestras/principal/PrevisualizarResultados.vue'),
						props: true,
					},
					{
						path: 'certificados',
						name: 'certificados',
						component: () => import('@/views/muestras/principal/Certificados.vue')
					}
				]
			}
		],
	}
]
export default muestrasRouter;